import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { _noop } from 'underscore-es';
import { ArchiveIcon, ActiveIcon, PausedIcon } from '../SVGs/Icons';
import { useToggle } from '../../../libs/react-use-extra';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import { Select, OptionContent } from './StatusPicker.styled';

const LOADING_VALUE = Symbol('loading');

const StatusPicker = ({
  value,
  onChange = _noop,
  isDisabled = false,
  isLoading = false,
}) => {
  const [
    isArchiveConfirmationOpen,
    { on: openArchiveConfirmation, off: closeArchiveConfirmation },
  ] = useToggle();

  const archive = () => {
    onChange('archived');
  };

  const handleChange = event => {
    const newStatus = event.target.value;
    if (newStatus === 'archived') {
      openArchiveConfirmation();
    } else {
      onChange(newStatus);
    }
  };

  return (
    <>
      <Select
        value={isLoading ? LOADING_VALUE : value}
        onChange={handleChange}
        disabled={isLoading || isDisabled}
      >
        {isLoading && (
          <Select.Option value={LOADING_VALUE} disabled>
            Loading <CircularProgress size={16} />
          </Select.Option>
        )}
        <Select.Option value="active">
          <OptionContent>
            <ActiveIcon /> Active
          </OptionContent>
        </Select.Option>
        <Select.Option value="paused">
          <OptionContent>
            <PausedIcon />
            Paused
          </OptionContent>
        </Select.Option>
        <Select.Option value="archived">
          <OptionContent>
            <ArchiveIcon /> Archived
          </OptionContent>
        </Select.Option>
      </Select>
      {isArchiveConfirmationOpen && (
        <ConfirmationDialog
          message="Are you sure you want to archive this campaign?"
          onConfirm={archive}
          onClose={closeArchiveConfirmation}
        />
      )}
    </>
  );
};

export default StatusPicker;
